module.exports = __webpack_public_path__ + "img/Passport.088fb872.svg";